import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { Http } from "@angular/http";
import { EbsWebService } from "../../services/ebsWebService";

@Component({
  selector: 'custom-header',
  templateUrl: 'custom-header.html',
  inputs: ['headerData']
})
export class CustomHeaderPage {

  headerData: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: Http,
    private _ebsWebService: EbsWebService,
    private toastCtrl: ToastController
  ) {
  }

  ionViewDidLoad() {
  }

  updateValue(value, element) {
    if (typeof element.Action == "undefined" || element.Action == null) {
      return;
    }
    let params = element.PostParameters + value;
    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);

    this._ebsWebService.postData(element.Action, postPayloadObject).toPromise().then(result => {
      if (result != null && typeof result != "undefined") {
        let toast = this.toastCtrl.create({
          message: "Daten wurden erfolgreich gespeichert!",
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      } else {
        let toast = this.toastCtrl.create({
          message: "Fehler beim Speichern der Daten.",
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/custom-header/custom-header.ts